import { ListRow, CellContainer } from './receivers-list-row.styles';
import { FontSizes } from '../../../common/typography/typography.styles';
import TruncatedTextWithTooltip from '../../../common/truncated-text-with-tooltip/truncated-text-with-tooltip.component';
import { getFullUserAddress } from '../../../utils/generic/generic.utils';
import { Recipient } from '../../../models/parcelDeliveryMiles';

interface Props {
  receiver: Recipient;
}

const ReceiversListRow = ({ receiver }: Props) => {
  const {
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    phone,
    address,
    email,
  } = receiver;

  return (
    <ListRow tabIndex={0}>
      <CellContainer $width='24rem'>
        <TruncatedTextWithTooltip
          textType='label'
          fontSize={FontSizes.small}>
          {[firstName, middleName, lastName].filter(Boolean).join(' ')}
        </TruncatedTextWithTooltip>
      </CellContainer>

      <CellContainer $width='16rem'>
        <TruncatedTextWithTooltip
          textType='label'
          fontSize={FontSizes.small}>
          {phone?.phone_number || ''}
        </TruncatedTextWithTooltip>
      </CellContainer>

      <CellContainer $width='24rem'>
        <TruncatedTextWithTooltip
          textType='label'
          fontSize={FontSizes.small}>
          {email || ''}
        </TruncatedTextWithTooltip>
      </CellContainer>

      <CellContainer $width='35rem'>
        <TruncatedTextWithTooltip
          textType='label'
          fontSize={FontSizes.small}>
          {getFullUserAddress(address) || ''}
        </TruncatedTextWithTooltip>
      </CellContainer>
    </ListRow>
  );
};

export default ReceiversListRow;
